
<template>
  <div :class="[formGroupClass,'form-group']">
    <label class="control-label" v-if="alias">{{ alias }}:</label>
    <select
      ref="input"
      type="text"
      class="form-control form-control-sm"
      :class="{ 'is-invalid' : getError }"
      :value="value"
      :name="name"
      :placeholder="placeholder"
      @input="onInput"
      @change="onChange"
      @blur="onBlur"
      :disabled="disabled"
    >
      <option v-for="(row, index) in options" :value="index" :selected="index == value" :key="index">{{ row }}</option>
    </select>
    <div class="invalid-feedback invalid-feedback-overwrite" v-if="getError">{{ getError }}</div>
  </div>
</template>

<script>
export default {
  props: {
    value: {},

    options: {},

    formGroupClass: {},

    name: {},

    alias: {},

    placeholder: {},

    disabled : {
      default : false
    },

    form: {},

    error: {}
  },

  computed: {
    getError() {
      if (this.form !== {} && this.form !== undefined) {
        return this.form.getErrors(this.name);
      }
      return false;
    }
  },

  methods: {

    focus() {
      this.$refs.input.focus();
    },

    onInput(event) {
      this.$emit("input", event.target.value);
    },

    onChange(event) {
      this.$emit("input", event.target.value);
    },

    onBlur(event) {
      this.$emit("blur");
      this.validate(event);
    },

    validate(event) {
      if (this.form != undefined) {
        this.form.validate(this.name);
      }
    }
  }
};
</script>

<style>
.invalid-feedback-overwrite {
  font-size: 12px;
}
</style>

